import React from "react";
import { Link } from "react-router-dom";
import { Dropdown } from "semantic-ui-react";

const UserAppHeaderDropdown = () => (
  <Dropdown text="Maintenance" simple item>
    <Dropdown.Menu>
      <Dropdown.Item as={Link} to="/maintenance/flight-schedules-import">
        Flight Schedules Import
      </Dropdown.Item>
    </Dropdown.Menu>
  </Dropdown>
);

export default UserAppHeaderDropdown;



// WEBPACK FOOTER //
// ./src/component/dropdowns/MaintenanceAppHeaderDropdown.js